import uniqueId from 'lodash/uniqueId';
import * as CONST from './const';
import blockFactory from './blocks/factory';
import actionParser from './props/action';
import sizeTrait from './props/size-trait';
import background from './props/background';
import { MATCH_VIEWPORT, MATCH_PARENT } from './props/predefined-size';
import { sumWeight, getMaxWeight } from '../util';

/**
 * Парсинг DIV карточки
 * @param  {{Array} states, {Object} background} options.body
 * @param  {Number} options.state_id
 * @param  {String} options.type
 * @return {Object}
 */
export default (function (card) {
    if (!card) {
        return null;
    }

    var _card$body = card.body,
        body = _card$body === undefined ? {} : _card$body,
        _card$state_id = card.state_id,
        state_id = _card$state_id === undefined ? CONST.DEFAULT_DIV_STATE_ID : _card$state_id;


    if (!body.states || !Array.isArray(body.states)) {
        return null;
    }

    var stateId = String(state_id);
    var states = statesFactory(body.states);
    var stateIndex = states.findIndex(function (_ref) {
        var id = _ref.id;
        return id === stateId;
    });

    if (stateIndex === -1) {
        return null;
    }

    var hasGallery = states.some(function (state) {
        return state.hasGallery;
    });
    var hasTabs = states.some(function (state) {
        return state.hasTabs;
    });

    var width = hasGallery || hasTabs ? MATCH_VIEWPORT : sizeTrait(body.width, MATCH_PARENT);

    return {
        hasTabs: hasTabs,
        hasGallery: hasGallery,
        states: states,
        stateIndex: stateIndex,
        width: width,
        background: background(body.background),
        type: card.type,
        id: uniqueId('card_'),
        weight: getMaxWeight(states)
    };
});

var statesFactory = function statesFactory(states) {
    return states.map(function (state) {
        if (!state) {
            return null;
        }

        if (!state.blocks) {
            return null;
        }

        var blocks = state.blocks.map(blockFactory).filter(Boolean);

        if (!blocks.length) {
            return null;
        }

        var hasGallery = blocks.some(function (block) {
            return block.hasGallery;
        });
        var hasTabs = blocks.some(function (block) {
            return block.hasTabs;
        });

        return {
            id: String(state.state_id),
            blocks: blocks,
            hasGallery: hasGallery,
            hasTabs: hasTabs,
            action: actionParser(state),
            weight: sumWeight(blocks)
        };
    }).filter(Boolean);
};